/** Friendly KB titles (URL slug / portal area), not RBAC "X Management" names. */

export function getKbModuleDisplayName(module) {
  if (!module) return "Module";

  const slug = String(module.slug || "").trim();
  if (slug) {
    return slug
      .split("-")
      .filter(Boolean)
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  }

  const raw = module.name || module.moduleName || "";
  const trimmed = String(raw).replace(/\s+Management$/i, "").trim();
  return trimmed || raw || "Module";
}

export const KB_MODULE_SELECT_CLASS = "kb-module-select";

/** Shared Select menu — portals above Dialog so clicks stay responsive. */
export const KB_MODULE_MENU_PROPS = {
  disablePortal: false,
  keepMounted: false,
  disableScrollLock: true,
  PaperProps: {
    className: "kb-module-menu",
  },
  MenuListProps: {
    className: "kb-module-menu-list",
    dense: true,
  },
  anchorOrigin: { vertical: "bottom", horizontal: "left" },
  transformOrigin: { vertical: "top", horizontal: "left" },
  sx: { zIndex: 1600 },
};

export const KB_PAGE_MENU_PROPS = {
  ...KB_MODULE_MENU_PROPS,
  anchorOrigin: { vertical: "bottom", horizontal: "right" },
  transformOrigin: { vertical: "top", horizontal: "right" },
};
